import { render, staticRenderFns } from "./Ask.vue?vue&type=template&id=c7d7ff28&scoped=true&"
import script from "./Ask.vue?vue&type=script&lang=js&"
export * from "./Ask.vue?vue&type=script&lang=js&"
import style0 from "./Ask.vue?vue&type=style&index=0&id=c7d7ff28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d7ff28",
  null
  
)

export default component.exports